import http from "@/services/http";

export async function fetch(country: string) {
  const { data } = await http().get(
    window.env.API_COMMERCE + "/states/" + country
  );
  return data.states;
}
